<template>
  <!-- <pre v-if="responseData">  test data :: {{ responseData }}</pre>  -->
  <AdminBackground v-if="responseData">
    <div class="content-wrapper">
      <div class="image-wrapper">
        <img
          src="@/assets/header/PENGGUNA API.png"
          alt="PENGGUNA API"
          class="pbt-image"
        >
        <!-- Center the line under the image -->
        <div class="line-under-image" />
      </div>
      <div class="pbtpay-status">
        <VRow>
          <VCol cols="12">
            <VCard>
              <VCardText class="d-flex align-center justify-space-between flex-wrap gap-4">
                <div class="d-flex gap-2 align-center">
                  <p class="text-body-1 mb-0">
                    Tunjukkan
                  </p>
                  <AppSelect
                    :model-value="itemsPerPage"
                    :items="[
                      { value: 5, title: '5' },
                      { value: 25, title: '25' },
                      { value: 50, title: '50' },
                      { value: 100, title: '100' },
                      { value: -1, title: 'All' },
                    ]"
                    style="inline-size: 5.5rem;"
                    @update:model-value="itemsPerPage = parseInt($event, 10)"
                  />
                </div>

                <div class="d-flex align-center gap-4 flex-wrap">
                  <AppTextField
                    v-model="search"
                    placeholder="Cari Pengguna"
                    style="inline-size: 15.625rem;"
                  />
                  <VBtn
                    density="default"
                    prepend-icon="tabler-plus"
                    @click="isAddUserDialogVisible = true"
                  >
                    Tambah Pengguna
                  </VBtn>
                </div>
              </VCardText>

              <VDivider />

              <VDataTableServer
                v-model:items-per-page="itemsPerPage"
                v-model:page="page"
                :items-length="totalPermissions"
                :items-per-page-options="[
                  { value: 5, title: '5' },
                  { value: 10, title: '10' },
                  { value: -1, title: '$vuetify.dataFooter.itemsPerPageAll' },
                ]"
                :headers="headers"
                :items="permissions"
                item-value="name"
                class="text-no-wrap"
                @update:options="updateOptions"
              >
                <!-- Name -->
                <template #item.name="{ item }">
                  <div class="text-high-emphasis text-body-1">
                    {{ item.name }}
                  </div>
                </template>

                <!-- Assigned To -->
                <!--
                  <template #item.assignedTo="{ item }">
                  <div class="d-flex flex-column gap-3">
                  <VChip
                  v-for="text in item.assignedTo"
                  :key="text"
                  label
                  size="small"
                  :color="colors[text].color"
                  class="font-weight-medium"
                  >
                  {{ colors[text].text }}
                  </VChip>
                  </div>
                  </template> 
                -->


                <!-- Peranan -->
                <template #item.assignedTo="{ item }">
                  <div class="d-flex flex-column gap-3">
                    <VChip
                      v-for="role in item.api_types"
                      :key="role.id"
                      label
                      size="small"
                      class="font-weight-medium"
                    >
                      {{ role.name }}
                    </VChip>
                  </div>
                </template>

                <!-- Suspended -->
                <template #item.is_suspended="{ item }">
                  <div>{{ item.is_suspended ? 'Yes' : 'No' }}</div>
                </template>

                <template #bottom>
                  <TablePagination
                    v-model:page="page"
                    :items-per-page="itemsPerPage"
                    :total-items="totalPermissions"
                  />
                </template>

                <!-- Actions -->
                <template #item.actions="{ item }">
                  <span
                    style="color: blue; cursor: pointer;"
                    @click="showEditDialog(item)"
                  >Edit</span>
                  <span
                    style="color: red; cursor: pointer; margin-left: 10px;"
                    @click="showDeleteDialog(item)"
                  >Delete</span>
                </template>
              </VDataTableServer>
            </VCard>

   
            <VDialog
              v-model="isAddUserDialogVisible"
              max-width="500"
            >
              <VCard>
                <VCardTitle class="headline">
                  Tambah Pengguna
                </VCardTitle>
                <VCardText>
                  <div class="form-row">
                    <VTextField
                      v-model="newUser.name"
                      label="Nama"
                    />
                  </div>
                  <div class="form-row">
                    <VSelect
                      v-model="newUser.role"
                      :items="roles"
                      label="Peranan"
                      multiple
                    />
                  </div>
                  <div class="form-row">
                    <VTextField
                      v-model="newUser.email"
                      label="Emel"
                    />
                  </div>
                </VCardText>
                <VCardActions>
                  <VSpacer />
                  <VBtn
                    color="grey"
                    @click="isAddUserDialogVisible = false"
                  >
                    Tutup
                  </VBtn>
                  <VBtn
                    color="green"
                    @click="addUser"
                  >
                    Simpan
                  </VBtn>
                </VCardActions>
              </VCard>
            </VDialog>


            <VDialog
              v-model="isEditDialogVisible"
              max-width="500"
            >
              <VCard>
                <VCardTitle class="headline">
                  Edit Pengguna
                </VCardTitle>
                <VCardText>
                  <div class="form-row">
                    <VTextField
                      v-model="editUser.name"
                      label="Nama"
                    />
                  </div>
                  <div class="form-row">
                    <VSelect
                      v-model="editUser.role"
                      :items="roles"
                      label="Peranan"
                      multiple
                    />
                  </div>
                  <div class="form-row">
                    <VTextField
                      v-model="editUser.email"
                      label="Emel"
                    />
                  </div>
                  <div class="form-row">
                    <VTextField
                      v-model="editUser.password"
                      label="Suspended"
                    />
                  </div>
                </VCardText>
                <VCardActions>
                  <VSpacer />
                  <VBtn
                    color="secondary"
                    @click="isEditDialogVisible = false"
                  >
                    Tutup
                  </VBtn>
                  <VBtn
                    color="success-darken-1"
                    @click="saveEdit"
                  >
                    Simpan
                  </VBtn>
                </VCardActions>
              </VCard>
            </VDialog>


            <VDialog
              v-model="isDeleteDialogVisible"
              max-width="400"
            >
              <VCard>
                <VCardText class="text-center">
                  <VIcon
                    size="64"
                    color="orange"
                  >
                    tabler-alert-octagon
                  </VIcon>
                  <div class="dialog-title">
                    <strong>Pasti?</strong>
                  </div>

                  <p>Data pengguna ini akan dibuang!</p>
                </VCardText>
                <VCardActions class="justify-center">
                  <VBtn
                    color="primary"
                    class="white--text"
                    @click="confirmDelete"
                  >
                    Ya, buang
                  </VBtn>
                  <VBtn
                    color="error"
                    class="white--text"
                    @click="isDeleteDialogVisible = false"
                  >
                    Batal
                  </VBtn>
                </VCardActions>
              </VCard>
            </VDialog>
          </VCol>
        </VRow>
      </div>
    </div>
  </AdminBackground>
  <PrimaryModule />
</template>

<script setup>
import { useHttpService } from "@/httpService"
import { computed, onMounted, ref } from 'vue'
import axios from 'axios'


definePage({
  alias: '/pages/pages/inspektorat/ahli-pbt',
  meta: {
    layout: 'blank',
    public: true,
  },
})

const ApiUrl = import.meta.env.VITE_LOGIN_API_URL
const token = localStorage.getItem('token')

const axiosAuth = axios.create({
  baseURL: ApiUrl,
  headers: {
    Authorization: `Bearer ${token}`,
  },
})

const headers = [
  { title: 'Nama Vendor', key: 'name' },
  { title: 'email', key: 'email' },
  { title: 'Peranan', key: 'assignedTo', sortable: false },
  { title: 'Suspended', key: 'is_suspended', sortable: false },
  { title: 'Actions', key: 'actions', sortable: false },
]

const search = ref('')
const itemsPerPage = ref(10)
const page = ref(1)
const sortBy = ref()
const orderBy = ref()

const updateOptions = options => {
  sortBy.value = options.sortBy?.[0]?.key
  orderBy.value = options.sortBy?.[0]?.order
}


const isAddUserDialogVisible = ref(false)
const isEditDialogVisible = ref(false)
const isDeleteDialogVisible = ref(false)


const newUser = ref({
  name: '',
  role: [],
  email: '',
  password: '',
})

const editUser = ref({
  name: '',
  role: [],
  email: '',
  password: '',
})

const { loading, error, httpDelete, httpPostPut, httpGet, httpPost,
  numberWithCommas,
  formatToMillion, calculatePercentage } = useHttpService()

const responseData = ref(null)

async function loadDataFromApi() {
  try {
    const response = await axiosAuth.get('api-users')

    responseData.value = response.data   // <-- FIXED HERE
  } catch (err) {
    console.error('loadDataFromApi failed:', err)
  }
}


onMounted(() => {
  loadDataFromApi()
})



const filteredPermissions = computed(() => {
  let filtered = responseData.value || []
  if (search.value) {
    filtered = filtered.filter(user =>
      user.name.toLowerCase().includes(search.value.toLowerCase()),
    )
  }
  
  return filtered
})

const permissions = computed(() => {
  const start = (page.value - 1) * itemsPerPage.value
  const end = start + itemsPerPage.value
  
  return filteredPermissions.value.slice(start, end)
})

const totalPermissions = computed(() => filteredPermissions.value.length)

const addUser = () => {
  console.log("Adding user:", newUser.value)


  newUser.value = { name: '', role: [], email: '', password: '' }
  isAddUserDialogVisible.value = false
}

const showEditDialog = item => {
  editUser.value = { ...item } 
  isEditDialogVisible.value = true
}

const saveEdit = () => {
  const index = responseData.value.findIndex(user => user.id === editUser.value.id)
  if (index !== -1) {
    responseData.value[index] = { ...editUser.value }
  }
  isEditDialogVisible.value = false
}


const showDeleteDialog = item => {
  editUser.value = { ...item } 
  isDeleteDialogVisible.value = true
}

const confirmDelete = () => {
  const index = responseData.value.findIndex(user => user.id === editUser.value.id)
  if (index !== -1) {
    responseData.value.splice(index, 1)
  }
  isDeleteDialogVisible.value = false
}
</script>


<style scoped>
.content-wrapper {
  display: flex;
  flex-direction: column;
  align-items: center;
  padding: 20px;
  inline-size: 100%;
}

.image-wrapper {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  margin-block-end: 20px;
}

.pbt-image {
  block-size: auto;
  max-inline-size: 70%; /* Adjusted size */
}

.line-under-image {
  border-radius: 5px;
  background-color: white;
  block-size: 5px;
  inline-size: 70%; /* Match width to the image size */
  margin-block-start: 10px;
}

/* Gap between line and the map */
.map-gap {
  margin-block: 10px; /* Increase this for more gap */
}

h2 {
  display: block;
  color: #150069;
  font-size: 30px;
  font-weight: 600;
  font-weight: bold;
  margin-block-end: 20px;
  text-align: start;
}


.pbtpay-status {
  display: flex;
  flex-direction: column;
  padding: 20px;
  border-radius: 10px;
  background-color: rgba(255, 255, 255, 65%);
  box-shadow: 0 4px 15px rgba(0, 0, 0, 20%);
  inline-size: 100%;
  margin-block-end: 50px;
  max-inline-size: 1200px;
}

.pbtpay-box {
  display: flex;
  flex-wrap: wrap;
  justify-content: space-between;
  margin-block-end: 30px;
}

.form-row {
  margin-bottom: 16px; 
}
</style>
